/**
 * QR Codes Domain Menu Provider
 * Sidebar navigation for QR Code Management module
 */

import {
  IconQrcode,
  IconList,
  IconPlus,
  IconDashboard,
  IconUser,
  IconSettings,
  IconFrame,
  IconDatabase,
  IconPhoto,
} from '@tabler/icons-react';
import { DomainMenuProvider, MenuSection } from '../../layouts/menu/types';
import { createVisibilityCheck } from './BaseMenuProvider';

class QrCodesMenuProvider implements DomainMenuProvider {
  domainId = 'qr-codes';

  getMenuConfig() {
    const sections: MenuSection[] = [
      // Overview Section
      {
        id: 'qrcodes-overview',
        label: 'Overview',
        items: [
          {
            id: 'qrcodes-dashboard',
            label: 'Dashboard',
            path: '/app/qr-codes',
            icon: <IconDashboard size={16} />,
          },
          {
            id: 'qrcodes-list',
            label: 'All QR Codes',
            path: '/app/qr-codes/list',
            icon: <IconList size={16} />,
          },
          {
            id: 'qrcodes-my-codes',
            label: 'My QR Codes',
            path: '/app/qr-codes/my-codes',
            icon: <IconUser size={16} />,
          },
          {
            id: 'qrcodes-create',
            label: 'Create QR Code',
            path: '/app/qr-codes/create',
            icon: <IconPlus size={16} />,
          },
        ],
      },

      // Administration Section
      {
        id: 'qrcodes-admin',
        label: 'Administration',
        items: [
          {
            id: 'qrcodes-frames',
            label: 'Frame Templates',
            path: '/app/qr-codes/admin/frames',
            icon: <IconFrame size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'qrcodes-assets',
            label: 'Asset Library',
            path: '/app/qr-codes/admin/assets',
            icon: <IconPhoto size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'qrcodes-lookups',
            label: 'Lookups',
            path: '/app/qr-codes/admin/lookups',
            icon: <IconDatabase size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'qrcodes-settings',
            label: 'Settings',
            path: '/app/qr-codes/admin/settings',
            icon: <IconSettings size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },
    ];

    return {
      domainId: this.domainId,
      sections,
      metadata: {
        version: '1.0.0',
        lastUpdated: Date.now(),
      },
    };
  }
}

export const qrCodesMenuProvider = new QrCodesMenuProvider();
